import React, { useEffect, useState } from "react";
import { Container, Title, Text, Button, MantineProvider } from "@mantine/core";
import { useNavigate, useLocation } from "react-router-dom";
import {Footer} from "./Footer/Footer";
import styles from "./SplashLanding.module.css";
import { unsubscribe } from "../api";

const theme = {
  components: {
    Button: {
      styles: {
        root: {
          transition: "background-color 0.3s ease-in-out",
          "&:hover": {
            backgroundColor: "rgba(15, 45, 45, 0.75)",
            color: "white",
          },
        },
      },
    },
  },
};

function UnsubscribePage() {
  const navigate = useNavigate();
  const location = useLocation();
  const [message, setMessage] = useState(
    "Processing your unsubscribe request...",
  );
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const email = searchParams.get("email");

    if (email) {
      // Decode the email before sending it to the API
      const decodedEmail = decodeURIComponent(email);
      unsubscribe(decodedEmail)
        .then((response) => {
          setMessage(response.message);
        })
        .catch((error) => {
          setMessage(
            "An error occurred while processing your request. Please try again later.",
          );
          setIsError(true);
        });
    } else {
      setMessage(
        "Invalid unsubscribe link. Please check your email and try again.",
      );
      setIsError(true);
    }
  }, [location]);

  return (
    <MantineProvider theme={theme}>
      <div
        style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}
      >
        <Container
          size="md"
          style={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
            padding: "50px 0",
          }}
        >
          <img
            src="/static/Socius_DRK.svg"
            alt="Socius Legal"
            className={styles.logo}
            style={{ marginBottom: "2rem", maxWidth: "200px" }}
          />
          <Title order={1}>
            {isError ? "Unsubscribe Error" : "Unsubscribe Successful"}
          </Title>
          <Text size="lg" mt="md">
            {message}
          </Text>
          <Button
            onClick={() => navigate("/")}
            mt="xl"
            className={styles.getStartedBtn}
            size="md"
            style={{
              backgroundColor: "var(--accent-gold)",
              transition: "background-color 0.3s ease-in-out",
            }}
            onMouseEnter={(e) =>
              (e.currentTarget.style.backgroundColor =
                "var(--accent-gold-hover)")
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.backgroundColor = "var(--accent-gold)")
            }
          >
            Return to Home
          </Button>
        </Container>
        {Footer()}
      </div>
    </MantineProvider>
  );
}

export default UnsubscribePage;
